import Vue from 'vue' //引入vue
import VueRouter from 'vue-router' //引入vue-router模块
// 引入进度条组件
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store/store'
NProgress.configure({
	showSpinner: false
})

Vue.use(VueRouter) //声明安装路由
const routes = [{
		name: '首页',
		path: '/',
		redirect: '/index'
	},
	{
		name: '首页',
		path: "/index",
		component: () => import('@/components/index/index'),
	}, //主页search
	{
		name: '搜索结果',
		path: "/search",
		component: () => import('@/components/index/search'),
	}, //搜索结果
	{
		name: '产品中心',
		path: "/product",
		component: () => import('@/components/product/product'),
	}, //产品中心
	{
		name: '商品详情',
		path: "/products/:id",
		component: () => import('@/components/product/goodsDetails'),
	}, //产品详情
	{
		name: '商品详情旧链接重定向',
		path: "/goodsDetails",
		redirect: to => {
			const gid = to.query.gid;
			if (gid) {
				return `/products/${gid}`;
			}
			return '/product';
		}
	}, //旧链接重定向
	{
		name: '产品一级',
		path: "/oneDetails",
		component: () => import('@/components/product/oneDetails'),
	}, //分类详情
	{
		name: '文献下载',
		path: "/technology",
		component: () => import('@/components/technology/technology'),
	}, //文献下载
	{
		name: '学习资料',
		path: "/studyData",
		component: () => import('@/components/technology/studyData'),
	}, //学习资料
	{
		name: '索取资料',
		path: "/askData",
		component: () => import('@/components/technology/askData'),
	}, //索取资料tool
	{
		name: '实验工具',
		path: "/tool",
		component: () => import('@/components/technology/tool'),
	}, //实验工具
	{
		name: '摩尔浓度计算器',
		path: "/molalityCalculator",
		component: () => import('@/components/technology/molalityCalculator'),
	}, //摩尔浓度计算器
	{
		name: '稀释计算器',
		path: "/dilutionCalculator",
		component: () => import('@/components/technology/dilutionCalculator'),
	}, //稀释计算器
	
	{
		name: '说明书下载',
		path: "/explain",
		component: () => import('@/components/technology/explain'),
	}, //说明书下载
	{
		name: '产品视频',
		path: "/video",
		component: () => import('@/components/technology/video'),
	}, //产品视频
	{
		name: '产品操作视频',
		path: "/videos/:id",
		component: () => import('@/components/technology/videoDetails'),
	}, //产品操作视频
	{
		name: '视频详情旧链接重定向',
		path: "/videoDetails",
		redirect: to => {
			const gid = to.query.gid;
			if (gid) {
				return `/videos/${gid}`;
			}
			return '/technology';
		}
	}, //视频旧链接重定向
	{
		name: '积分兑换',
		path: "/integral",
		component: () => import('@/components/integral/integral'),
	}, //积分兑换
	{
		name: '积分确认订单',
		path: "/integralConvert",
		meta: {
			requireAuth: true, 
		},
		component: () => import('@/components/integral/integralConvert'),
	}, //积分确认订单
	{
		name: '积分兑换订单',
		path: "/integralOredr",
		meta: {
			requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
		},
		component: () => import('@/components/integral/integralOredr'),
	}, //积分订单
	//
	{
		name: '申请vip',
		path: '/applyVip',
		meta: {
			requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
		},
		component: () => import('@/components/integral/applyVip'),
	},//申请vip
	{
		name: '活动专区',
		path: "/activity",
		component: () => import('@/components/activity/activity'),
	}, //活动专区
	{
		name: '活动详情',
		path: "/activityDetails",
		component: () => import('@/components/activity/activityDetails'),
	}, //活动详情
	{
		name: '新闻动态',
		path: '/journalism',
		redirect: '/journalism/news'
	},//新闻动态
	{
		name: '新闻动态',
		path: "/journalism/:lit",
		component: () => import('@/components/journalism/journalism'),
	}, //新闻动态
	{
		name: '新闻动态详情',
		path: "/jourDetails",
		component: () => import('@/components/journalism/jourDetails'),
	}, //新闻动态
	//
	{
		name: '走进东仁',
		path: "/aboutUs",
		component: () => import('@/components/aboutUs/aboutUs'),
		children:[
			{
				name:"订货流程",
				path:"/aboutUs/flow",
				component:() => import('@/components/aboutUs/flow')
			},//订货流程
			{
				name:"联系我们",
				path:"/aboutUs/joinUs",
				component:() => import('@/components/aboutUs/joinUs')
			},//联系我们
			{
				name:"加入我们",
				path:"/aboutUs/contactUs",
				component:() => import('@/components/aboutUs/contactUs')
			},//加入我们
			{
				name:"公司介绍",
				path:"/aboutUs/about",
				component:() => import('@/components/aboutUs/about')
			},//公司介绍
		]
	}, //新闻动态
	{
		name: '登录',
		path: "/login",
		component: () => import('@/components/login/login'),
	},//登录
	{
		name: '注册',
		path: "/register",
		component: () => import('@/components/login/register'),
	},//注册
	{
		name: '注册二维码',
		path: "/erw",
		component: () => import('@/components/login/erw'),
	},//注册二维码
	{
		name: '忘记密码',
		path: "/forgetPwd",
		component: () => import('@/components/login/forgetPwd'),
	},//忘记密码
	{
		name: '用户协议',
		path: "/userAgreement",
		component: () => import('@/components/login/userAgreement'),
	},//用户协议
	{
			name: '个人中心',
			path: '/personalCenter',
			redirect: '/personalCenter/personal'
	},
	{
		name: '个人中心',
		path: "/personalCenter",
		meta: {
			requireAuth: true,
		},
		component: () => import('@/components/personalCenter/personalCenter'),
		children:[
			{
				name: '个人资料',
				path: "/personalCenter/personal",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/personal'),
			},//个人资料
			{
				name: '头像修改',
				path: "/personalCenter/head",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/head'),
			},//头像修改
			{
				name: '申请VIP',
				path: "/personalCenter/applyVip",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/applyVip'),
			},//申请VIP
			{
				name: '忘记密码',
				path: "/personalCenter/changePassword",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/changePassword'),
			},//忘记密码
			{
				name: '积分信息',
				path: "/personalCenter/credits",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/credits'),
			},//积分信息
			{
				name: '我的留言',
				path: "/personalCenter/leave",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/leave'),
			},//我的留言
			{
				name: '地址管理',
				path: "/personalCenter/site",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/site'),
			},//地址管理
			{
				name: '发票管理',
				path: "/personalCenter/invoice",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/invoice'),
			},//发票管理
			{
				name: '我的订单',
				path: "/personalCenter/orderForm",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/orderForm'),
			},//我的订单
			{
				name: '我的积分',
				path: "/personalCenter/miOrder",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/miOrder'),
			},//我的积分
			{
				name: '我的发票',
				path: "/personalCenter/myInvoice",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/myInvoice'),
			},//我的发票
			{
				name: '我的足迹',
				path: "/personalCenter/history",
				meta: {
					requireAuth: true,
				},
				component: () => import('@/components/personalCenter/history'),
			},//我的足迹
		]
	},//个人中心
	{
			name: '购物车',
			path: '/shopping',
			meta: {
				requireAuth: true,
			},
			component: () => import('@/components/shopping/shopping'),
	},//购物车
	{
			name: '确认订单',
			path: '/order',
			meta: {
				requireAuth: true,
			},
			component: () => import('@/components/shopping/order'),
	},//确认订单
	{
			name: '订购协议',
			path: '/orderAgreement',
			component: () => import('@/components/shopping/orderAgreement'),
	},//订购协议
	{
			name: '订单成功',
			path: '/succeedOrder',
			meta: {
				requireAuth: true,
			},
			component: () => import('@/components/shopping/succeedOrder'),
	},//订单成功
	{
			name: '订单详情',
			path: '/orderDetails',
			meta: {
				requireAuth: true,
			},
			component: () => import('@/components/shopping/orderDetails'),
	},//订单详情
	{
			name: '积分订单',
			path: '/integral/orders/:id',
			meta: {
				requireAuth: true,
			},
			component: () => import('@/components/shopping/IntegralDetails'),
	},//积分订单
	{
			name: '积分订单旧链接重定向',
			path: '/IntegralDetails',
			redirect: to => {
				const gid = to.query.gid;
				if (gid) {
					return `/integral/orders/${gid}`;
				}
				return '/integral';
			}
	},//积分订单旧链接重定向
	{
		name: '404',
		path: '/*',
		component: () => import('@/components/nav/404'),
	},//对公账户
]
//
const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
// 处理旧的 hash 模式链接重定向到 history 模式
const handleHashRedirect = () => {
	const hash = window.location.hash;
	if (hash.startsWith('#/')) {
		let newPath = hash.substring(1);
		newPath = convertOldUrl(newPath);
		const newUrl = window.location.protocol + '//' + window.location.host + newPath;
		window.location.replace(newUrl);
		return true;
	}
	return false;
};

// 处理完整的旧链接格式（包括带 query 参数的情况）
const handleOldUrlFormat = () => {
	const hash = window.location.hash;
	if (hash.startsWith('#/')) {
		return false;
	}
	
	const path = window.location.pathname;
	const search = window.location.search;
	
	if (path === '/' && search.includes('gid=')) {
		const match = search.match(/[?&]gid=(\d+)/);
		if (match) {
			window.location.replace('/products/' + match[1]);
			return true;
		}
	}
	
	return false;
};

// 转换旧的URL格式到RESTful格式
const convertOldUrl = (path) => {
	if (path.startsWith('goodsDetails?gid=')) {
		const id = path.replace('goodsDetails?gid=', '');
		return '/products/' + id;
	}
	if (path.startsWith('videoDetails?gid=')) {
		const id = path.replace('videoDetails?gid=', '');
		return '/videos/' + id;
	}
	if (path.startsWith('IntegralDetails?gid=')) {
		const id = path.replace('IntegralDetails?gid=', '');
		return '/integral/orders/' + id;
	}
	return path;
};

// 清理URL中多余的查询参数（如 /products/1378?gid=1378 清理为 /products/1378）
const cleanUrlQueryParams = (to) => {
	const path = to.path;
	const query = to.query;
	
	if (path.startsWith('/products/') && query.gid) {
		const id = path.replace('/products/', '');
		if (id === query.gid.toString()) {
			window.history.replaceState({}, document.title, path);
			return true;
		}
	}
	
	if (path.startsWith('/videos/') && query.gid) {
		const id = path.replace('/videos/', '');
		if (id === query.gid.toString()) {
			window.history.replaceState({}, document.title, path);
			return true;
		}
	}
	
	if (path.startsWith('/integral/orders/') && query.gid) {
		const id = path.replace('/integral/orders/', '');
		if (id === query.gid.toString()) {
			window.history.replaceState({}, document.title, path);
			return true;
		}
	}
	
	return false;
};

// 添加路由守卫
router.beforeEach((to, from, next) => {
	if (handleHashRedirect()) {
		return;
	}
	if (handleOldUrlFormat()) {
		return;
	}
	cleanUrlQueryParams(to);
	document.title = to.name ? to.name : '同仁化学'
	if (to.meta.requireAuth) {     // 判断该路由是否需要登录权限
		let token = store.state.token||localStorage.getItem('token');
		if (!token){// 通过localStorage.getItem()获取当前的 token 是否存在
			if(from.query.redirect==to.fullPath)return;
			NProgress.start();
			router.push({path:'/login',query: {
				redirect: to.fullPath    // 将跳转的路由path作为参数，登录成功后跳转到该路由
			}})
		}else{
			NProgress.start();
			next()
		}
	}else{
		NProgress.start();
		next()
	}
})
// 后置路由守卫
router.afterEach((to, from) => {
	NProgress.done();
})

export default router
